// https://github.com/saadeghi/daisyui/blob/master/src/components/styled/loading.css

import clsx from 'clsx';

type Props = React.ComponentProps<'div'> & {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  padded?: string | boolean;
  centered?: boolean;
};
export function Spinner({
  size,
  className,
  padded,
  centered,
  ...props
}: Props): React.JSX.Element {
  const [height, width] =
    size === 'xs'
      ? ['h-2', 'w-2']
      : size === 'sm'
        ? ['h-4', 'w-4']
        : size === 'lg'
          ? ['h-10', 'w-10']
          : ['h-6', 'w-6'];

  return (
    <div
      className={clsx(
        'flex items-center justify-center',
        padded ? (typeof padded === 'string' ? padded : 'h-48') : height,
        centered && 'w-full'
      )}
    >
      <div
        {...props}
        aria-busy="true"
        style={{
          maskSize: '100%',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          maskImage: `url(
          "data:image/svg+xml,%3Csvg width='24' height='24' stroke='black' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform-origin='center'%3E%3Ccircle cx='12' cy='12' r='9.5' fill='none' stroke-width='3' stroke-linecap='round'%3E%3CanimateTransform attributeName='transform' type='rotate' from='0 12 12' to='360 12 12' dur='2s' repeatCount='indefinite'/%3E%3Canimate attributeName='stroke-dasharray' values='0,150;42,150;42,150' keyTimes='0;0.475;1' dur='1.5s' repeatCount='indefinite'/%3E%3Canimate attributeName='stroke-dashoffset' values='0;-16;-59' keyTimes='0;0.475;1' dur='1.5s' repeatCount='indefinite'/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E"
        )`,
        }}
        className={clsx(
          className,
          'pointer-events-none inline-block aspect-square bg-current',
          height,
          width
        )}
      />
    </div>
  );
}
